import { Table } from "antd";
import { EmptyState } from "@/shared/components/EmptyState";
import { useAttendanceColumns } from "../hooks/useAttendanceColumns";
import { useAttendanceTableData } from "../hooks/useAttendanceTableData";
import type { AttendanceTableProps, WorkerRow } from "../types";

export function AttendanceTable({
	organizationId,
	organizationName,
	startDate,
	endDate,
}: AttendanceTableProps) {
	const { tableData, isLoading } = useAttendanceTableData(
		organizationId,
		organizationName,
		startDate,
		endDate
	);
	const columns = useAttendanceColumns(startDate, endDate);

	return (
		<div className="overflow-hidden rounded-lg bg-white">
			<Table<WorkerRow>
				bordered
				size="small"
				rowKey="key"
				columns={columns}
				dataSource={tableData}
				loading={isLoading}
				scroll={{ x: "max-content" }}
				pagination={{
					pageSize: 10,
					showSizeChanger: true,
					pageSizeOptions: [10, 20, 50, 100],
					showTotal: (total) => `Jami: ${total} xodim`,
				}}
				locale={{
					emptyText: <EmptyState description="Ma'lumotlar topilmadi" />,
				}}
			/>
		</div>
	);
}
